import { useSetDocumentTitle } from "../../hooks/useSetDocumentTitle";
import { Page, Tooltip, Typography } from 'seagull';
import { useOverlayContext, useStore } from "../../contexts";
import InvoicesTable from "../../components/InvoicesTable/InvoicesTable";
import { selectors } from "../../store/state-selectors";
import { ErrorPage, NoInvoices } from "../../components/InvoicesEmptyStates/InvoicesEmptyStates";
import { ImportingInvoicesToQBOModal } from "./ImportingInvoicesToQBOModal";
import { QBOButton } from "./QBOButton";
import PageLoadingState from "../../components/PageLoadingState";
import { getAccountingDetails } from "../../integrations/Accounting/accounting.utils";
import { Accounting } from "../../types/api.model";
import styles from "./InvoicesDashboard.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const pageTitle = 'Invoices';
export default function InvoicesDashboard() {
  const isVendor = useStore(selectors.user.isVendor);
  const showQboIntegration = useStore(selectors.integration.showQboIntegration);
  const {
    showModal
  } = useOverlayContext();
  useSetDocumentTitle(pageTitle);
  return /*#__PURE__*/_jsx(InvoicesTable, {
    filtersClassname: styles.filters,
    renderLoader: () => /*#__PURE__*/_jsx(PageLoadingState, {
      header: pageTitle,
      loading: true,
      "data-testid": "invoices-dashboard-loading"
    }),
    renderError: _ref => {
      let {
        refresh
      } = _ref;
      return /*#__PURE__*/_jsx(ErrorPage, {
        title: pageTitle,
        retry: () => refresh()
      });
    },
    renderNoInvoices: () => /*#__PURE__*/_jsx(NoInvoices, {
      title: pageTitle,
      isVendor: isVendor
    }),
    renderChild: _ref2 => {
      let {
        tableContent,
        exportingCsv,
        exportCsv
      } = _ref2;
      return /*#__PURE__*/_jsx(Page, {
        "data-testid": "invoices-dashboard",
        header: pageTitle,
        subheader: /*#__PURE__*/_jsx(Typography, {
          children: "Manage and review your invoices"
        }),
        actions: isVendor && /*#__PURE__*/_jsx(Tooltip, {
          title: showQboIntegration ? '' : "Export the invoices displayed on this page to a CSV file in the format required for ".concat(getAccountingDetails(Accounting.QBO).name),
          placement: "bottom-end",
          children: /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(QBOButton, {
              "data-testid": "download-invoices-csv",
              hideIcon: showQboIntegration,
              loading: exportingCsv,
              onClick: async () => {
                exportCsv();
                if (!showQboIntegration) {
                  await showModal({
                    content: _ref3 => {
                      let {
                        dismissModal
                      } = _ref3;
                      return /*#__PURE__*/_jsx(ImportingInvoicesToQBOModal, {
                        "data-testid": "importing-invoices-to-qbo-modal",
                        onClose: dismissModal,
                        downloadCsv: exportCsv
                      });
                    }
                  });
                }
              },
              children: "Export to CSV"
            })
          })
        }),
        children: tableContent
      });
    }
  });
}